export const studentClasses = [
  { value: 'first-year', label: 'First Year' },
  { value: 'sophomore', label: 'Sophomore' },
  { value: 'junior', label: 'Junior' },
  { value: 'senior', label: 'Senior' },
];
